import { Component } from '@angular/core';

@Component({
  selector: 'app-digitize',
  standalone: true,
  imports: [],
  templateUrl: './digitize.html',
  styleUrl: './digitize.scss',
})
export class Digitize {}
